import React, { Component } from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import asyncValidate from "./asyncValidate";
import FormFieldsTabAddress from "../../form-fields/tab-address/tab-address";
class EditViewClientTabAddress extends Component {
  render() {
    return (
      <div>
        <FormFieldsTabAddress {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
EditViewClientTabAddress.propTypes = {
  locked: PropTypes.bool,
};
EditViewClientTabAddress = reduxForm({
  form: "ClientEditForm", // a unique Address for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabAddress);
export default EditViewClientTabAddress;
